export default "__VITE_ASSET__966283c7__"